import { render, staticRenderFns } from "./Verify-Email.vue?vue&type=template&id=5df93f6e"
import script from "./Verify-Email.vue?vue&type=script&lang=js"
export * from "./Verify-Email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports